import {Component} from '@angular/core';
import {BootstrapLicenseDataService} from '@core/services';

@Component({
  selector: 'app-sidebar-right',
  templateUrl: './sidebar-right.component.html',
  styleUrls: ['./sidebar-right.component.scss']
})
export class SidebarRightComponent {
  constructor(public bootstrapLicenseData: BootstrapLicenseDataService) {}
}
